export default {"src":"https://s.sylndr.com/c-4e2c349/_next/static/media/aboutUsIcon.d4ba4c84.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};